import { ApiService } from "./api.service";
// import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
export default class Journal extends ApiService {
  namespace = "journal";
  icon = "Spreadsheet";
  favicon = "ApplicationForm";
  name = "View Journal";
  View = 3;
  Width = 1200;
  columns = [
    {
      header: "Date",
      icon: "Calendar",
      field: "date",
      template: (data) => {
        return moment.unix(data.date).format("MM/DD/YYYY").format("MM/DD/YYYY");
      },
    },
    {
      header: this.t("account"),
      icon: "Money",
      field: "account",
    },
    {
      header: this.t("account"),
      icon: "Money",
      field: "account",
    },
    {
      header: this.t("description"),
      icon: "Money",
      field: "description",
    },
    {
      header: this.t("debit"),
      icon: "Money",
      field: "debit",
    },
    {
      header: this.t("credit"),
      icon: "Money",
      field: "credit",
    },
    {
      header: this.t("category"),
      icon: "Money",
      field: "category",
    },
    {
      header: this.t("entry"),
      icon: "Money",
      field: "entry",
    },
  ];
  constructor() {
    super("journal-entries");
  }
}
